export const buildModulePath = (moduleId: string, parentId?: string) => {
  const basePath = '/user/modules';
  return parentId ? `${basePath}/${parentId}/m/${moduleId}` : `${basePath}/${moduleId}`;
};

export const buildAgendaPath = (moduleId: string, agenda: { agendaId: string; systemType: string }, parentId?: string) => {
  const modulePath = buildModulePath(moduleId, parentId);
  return `${modulePath}/${agenda.systemType}/${agenda.agendaId}`;
};

export const buildViewPath = (moduleId: string, agenda: { agendaId: string; systemType: string }, viewId: string, parentId?: string) => {
  const agendaPath = buildAgendaPath(moduleId, agenda, parentId);
  return `${agendaPath}/view/${viewId}`;
};
